// @ts-nocheck legacy file transformed to TS
import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import Link from './Link'

// TODO: correct font size and unify with typography system
// kept the same to make it less jarring in the app during transition
export const Breadcrumbs = styled.div`
  display: flex;
`

export const Breadcrumb = styled.div`
  color: ${colors.GRAY_20};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:before {
    content: '/';
    margin: 0 4px;
  }

  &:first-child:before {
    content: '';
    margin: 0;
  }
`

export const CrumbLink = styled(Link)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${colors.GRAY_46};

  &:before {
    color: ${colors.GRAY_46};
    content: '/';
    margin: 0 4px;
  }
  &:first-child:before {
    content: '';
  }
  &:last-child {
    color: ${colors.GRAY_20};
  }
  &:hover {
    text-decoration: underline;
  }
`

export const BreadcrumbLink = props =>
  props.pathname && !props.pathname.match(props.to) ? null : <CrumbLink {...props} />
